import React, { Fragment } from "react";
import { isIOS, isAndroid } from "react-device-detect";
import { faApple, faGooglePlay } from "@fortawesome/free-brands-svg-icons";

import { Container } from "./styles";
import DownloadButton from "./components/DownloadButton";
import iPhoneMock from "../../../../assets/images/first-view-mockup.png";

const DownloadApp = () => {
  const renderAppleStoreButton = () => {
    return (
      <DownloadButton
        icon={faApple}
        topText="Disponível na"
        bottomText="APPLE STORE"
        className={isIOS ? "button-highlight" : "button"}
        href="https://apps.apple.com/br/app/estar-digital-curitiba-faz/id1497474349"
      />
    );
  };

  const renderPlayStoreButton = () => {
    return (
      <DownloadButton
        icon={faGooglePlay}
        topText="Disponível na"
        bottomText="PLAY STORE"
        className={isAndroid ? "button-highlight" : "button"}
        href="https://play.google.com/store/apps/details?id=com.estar.digital.curitiba.estacionamento.eletronico.rotativo.urbs.faz"
      />
    );
  };

  return (
    <Container>
      <div className="download-app-info">
        <h1 className="app-info-title">
          A evolução em estacionamento rotativo
        </h1>
        <p className="app-info-description">
          Com o app FAZ - Estar Digital Curitiba - você tem comodidade e agilidade na
          hora de estacionar seu veículo nas ruas de Curitiba. O APP é oficial, homologado pela URBS.
        </p>
        {isAndroid ? (
          <Fragment>
            {renderPlayStoreButton()}
            {renderAppleStoreButton()}
          </Fragment>
        ) : (
          <Fragment>
            {renderAppleStoreButton()}
            {renderPlayStoreButton()}
          </Fragment>
        )}
      </div>

      <div className="download-app-mock">
        <img src={iPhoneMock} alt="iPhone mockup" />
      </div>
    </Container>
  );
};

export default DownloadApp;
